import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";

/**
 * EmptyHolder: Component to display when FullWidthCard
 *              is not placed.
 */
export function EmptyHolder(props) {
  const onDrop = (event) => {
    event.preventDefault();
    props.onComponentDrop(event);
  };

  const onDragOver = (event) => {
    event.preventDefault();
  };

  return (
    <div
      className={`${style.fwCardPlaceholder} fwCard-placeholder`}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      + Add {props.componentName}
    </div>
  );
}

EmptyHolder.propTypes = {
  /**
   * Name of component to be displayed
   */
  componentName: PropTypes.string.isRequired,
  /**
   * Function to invoke when a component is dropped
   * here.
   */
  onComponentDrop: PropTypes.func.isRequired,
};

EmptyHolder.defaultProps = {
  componentName: "Component",
};
